import { render, staticRenderFns } from "./RateField.vue?vue&type=template&id=b0528f68&scoped=true&"
import script from "./RateField.vue?vue&type=script&lang=js&"
export * from "./RateField.vue?vue&type=script&lang=js&"
import style0 from "./RateField.vue?vue&type=style&index=0&id=b0528f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0528f68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
